var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',[_vm._v(" "+_vm._s(_vm.$tc('common.comprasion', _vm.comprasionResult))+" "+_vm._s(_vm.$t('stats.lol.match.team-stats.stats-title.teamwork'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }